import React from "react";
import { Link } from "react-router-dom"
import {Helmet} from "react-helmet";
import styled from "styled-components";
import {isMobile} from 'react-device-detect';

import TopMenu from "./menu-top"
import SiteHeader from "./header-site"
import SiteFooter from "./footer-site"

import maskIcon from "../images/mask.png"

import colors from "../settings/colors"

const Covid = styled.div`
  padding: 10px;
  background-color: #ff8500;
  margin: ${isMobile ? 60:10}px 10px 0px 10px;

  &:hover {
    opacity: .95;
    transform: scale(1.01);    
  }

  a {
    display: flex;
    align-items: center;
    text-decoration: none;
    color: white;

    &:hover {
      text-decoration: underline;
    }
  }

  img {
    margin-right: 15px;
  }
`

function Layout(props) {
  return (
    <>
        <Helmet>
            <meta charSet="utf-8" />
            <title>{props.title}</title>
        </Helmet>  

        <TopMenu page={props.page} />

        {/* {props.page != "covid" && 
          <Covid>
              <Link to="/covid">
                <img src={maskIcon} width="60" alt="Mask" border="0" />
                COVID Policy for all Marshall Artists Series Events
              </Link>
          </Covid>
        } */}

        <SiteHeader page={props.page} />  

        <div>
            {props.children}
        </div>

        <SiteFooter />
    </>
  );
}

export default Layout;